// import React, { useState, useEffect, useContext } from "react";
// import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useNavigate } from "react-router-dom";
// import CheckoutContext from "../contexts/CheckoutContext";

// const NAME_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]{3,}$/;
// const NUMBER_REGEX = /^[0-9]{1,}$/;
// const COMMUNE_REGEX = /^(Las Condes|Lo Barnechea|Vitacura)$/;
// const CITY_REGEX = /^[a-zA-Z]{3,}$/;
// const DN_REGEX = /^[0-9a-zA-Z_ ]{0,}$/;
// const HN_REGEX = /^[0-9a-zA-Z_ ]{0,}$/;


// function DeliveryForm (props) {
//     const navigate = useNavigate();
//     const { setDeliveryDirection, items, deliveryDate, clientData } = useContext(CheckoutContext);

//     const [name, setName] = useState("");
//     const [validName, setValidName] = useState(false);
//     const [nameFocus, setNameFocus] = useState(false);

//     const [number, setNumber] = useState("");
//     const [validNumber, setValidNumber] = useState(false);
//     const [numberFocus, setNumberFocus] = useState(false);

//     const [commune, setCommune] = useState("");
//     const [validCommune, setValidCommune] = useState(false);
//     const [communeFocus, setCommuneFocus] = useState(false);

//     const [city, setCity] = useState("Santiago");
//     const [validCity, setValidCity] = useState(true);
//     const [cityFocus, setCityFocus] = useState(false);

//     const [departmentNumber, setDepartmentNumber] = useState("");
//     const [validDepartmentNumber, setValidDepartmentNumber] = useState(false);
//     const [departmentNumberFocus, setDepartmentNumberFocus] = useState(false);

//     const [houseNumber, setHouseNumber] = useState("");
//     const [validHouseNumber, setValidHouseNumber] = useState(false);
//     const [houseNumberFocus, setHouseNumberFocus] = useState(false);

//     const [errMsg, setErrMsg] = useState("");

//     async function handleClickContinue (e) {
//         e.preventDefault();
//         // if button enabled with JS hack
//         const v1 = NAME_REGEX.test(name);
//         const v2 = NUMBER_REGEX.test(number);
//         const v3 = COMMUNE_REGEX.test(commune);
//         const v4 = CITY_REGEX.test(city);
//         const v5 = DN_REGEX.test(departmentNumber);
//         const v6 = HN_REGEX.test(houseNumber);
//         if (!v1 || !v2 || !v3 || !v4 || !v5 || !v6) {
//             setErrMsg("Invalid Entry");
//             return;
//         }

//         const data = {
//             streetName: name,
//             streetNumber: number,
//             commune,
//             city,
//             departmentNumber,
//             houseNumber
//         };

//         setDeliveryDirection(data);
//         navigate("/checkout/info");
//     };

//     useEffect(() => {
//         const result = NAME_REGEX.test(name);
//         setValidName(result);
//     }, [name]);

//     useEffect(() => {
//         const result = NUMBER_REGEX.test(number);
//         setValidNumber(result);
//     }, [number]);

//     useEffect(() => {
//         const result = COMMUNE_REGEX.test(commune);
//         setValidCommune(result);
//     }, [commune]);

//     useEffect(() => {
//         // const result = CITY_REGEX.test(city);
//         setValidCity(true);
//     }, [city]);

//     useEffect(() => {
//         const result = DN_REGEX.test(departmentNumber);
//         setValidDepartmentNumber(result);
//     }, [departmentNumber]);

//     useEffect(() => {
//         const result = HN_REGEX.test(houseNumber);
//         setValidHouseNumber(result);
//     }, [houseNumber]);

//     useEffect(() => {
//         setErrMsg('');
//     }, [name, number, commune, city, departmentNumber, houseNumber]);

//     return(
//         <div className="content-center px-8 py-6 text-left bg-white shadow-xl flex flex-col gap-4 mt-4 mx-2">
//             <p className={errMsg ? "bg-red-600 pl-4 rounded-lg" : "hidden"} aria-live="assertive">{errMsg}</p>
//             <p className="text-center text-3xl font-bold text-gray-600">Dirección de Despacho</p>
//             <form onSubmit={handleClickContinue} className="flex flex-col justify-evenly grow pb-4">

//                 <label htmlFor="city">
//                     Ciudad:
//                     <span className={validCity ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validCity || !city ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <input
//                     className="bg-gray-300 rounded-lg pl-2 mb-2"
//                     type="text"
//                     id="city"
//                     autoComplete="off"
//                     onChange={(e) => setCity(e.target.value)}
//                     value="Santiago"
//                     enabled="flase"
//                     required
//                     aria-invalid={validCity ? "false" : "true"}
//                     aria-describedby="cityNote"
//                     onFocus={() => setCityFocus(true)}
//                     onBlur={() => setCityFocus(false)}
//                 />
//                 <p id="cityNote" className={cityFocus && city &&
//                     !validCity ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         La ciudad debe tener un formato válido.
//                 </p>
                
//                 <label htmlFor="commune">
//                     Comuna:
//                     <span className={validCommune ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validCommune || !commune ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <select
//                     className="bg-gray-300 rounded-lg pl-2 mb-2"
//                     type="text"
//                     id="commune"
//                     autoComplete="off"
//                     onChange={(e) => setCommune(e.target.value)}
//                     required
//                     aria-invalid={validCommune ? "false" : "true"}
//                     aria-describedby="communeNote"
//                     >
//                     <option value="selecciona">seleccionar</option>
//                     <option value="Las Condes">Las Condes</option>
//                     <option value="Lo Barnechea">Lo Barnechea</option>
//                     <option value="Vitacura">Vitacura</option>
//                 </select>
//                 <p id="communeNote" className={communeFocus && commune &&
//                     !validCommune ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         La comuna debe tener un formato válido.
//                 </p>
                
//                 <label htmlFor="name">
//                     Calle:
//                     <span className={validName ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validName || !name ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <input
//                     className="bg-gray-300 rounded-lg pl-2 mb-2"
//                     type="text"
//                     id="name"
//                     autoComplete="off"
//                     onChange={(e) => setName(e.target.value)}
//                     required
//                     aria-invalid={validName ? "false" : "true"}
//                     aria-describedby="namenote"
//                     onFocus={() => setNameFocus(true)}
//                     onBlur={() => setNameFocus(false)}
//                 />
//                 <p id="namenote" className={nameFocus && name &&
//                     !validName ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         El nombre debe tener un formato válido.
//                 </p>

                
//                 <label htmlFor="number">
//                     Número:
//                     <span className={validNumber ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validNumber || !number ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <input
//                     className="bg-gray-300 rounded-lg pl-2 mb-2"
//                     type="text"
//                     id="number"
//                     autoComplete="off"
//                     onChange={(e) => setNumber(e.target.value)}
//                     required
//                     aria-invalid={validNumber ? "false" : "true"}
//                     aria-describedby="numbernote"
//                     onFocus={() => setNumberFocus(true)}
//                     onBlur={() => setNumberFocus(false)}
//                 />
//                 <p id="numbernote" className={numberFocus && number &&
//                     !validNumber ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         El número debe tener un formato válido.
//                 </p>


//                 <label htmlFor="departmentNumber">
//                     Número de departamento (contestar solo en caso de edificio):
//                     <span className={validDepartmentNumber && departmentNumber.length > 0  ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validDepartmentNumber || !departmentNumber ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <input
//                     className="bg-gray-300 rounded-lg pl-2 mb-2 w-full"
//                     type="text"
//                     id="departmentNumber"
//                     autoComplete="off"
//                     onChange={(e) => setDepartmentNumber(e.target.value)}
//                     aria-invalid={validDepartmentNumber ? "false" : "true"}
//                     aria-describedby="departmentNumberNote"
//                     onFocus={() => setDepartmentNumberFocus(true)}
//                     onBlur={() => setDepartmentNumberFocus(false)}
//                 />
//                 <p id="departmentNumberNote" className={departmentNumberFocus && departmentNumber &&
//                     !validDepartmentNumber ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         El número de departamento debe tener un formato válido.
//                 </p>

                
//                 <label htmlFor="houseNumber">
//                     Número de casa (contestar solo en caso de condominio):
//                     <span className={validHouseNumber && houseNumber > 0 ? "ml-2 text-green-600" : "hidden"}>
//                         <FontAwesomeIcon icon={faCheck} />
//                     </span>
//                     <span className={validHouseNumber || !houseNumber ? "hidden" : "ml-2 text-red-600"}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </span>
//                 </label>
//                 <input
//                     className="bg-gray-300 rounded-lg pl-2 mb-2 w-full"
//                     type="text"
//                     id="houseNumber"
//                     autoComplete="off"
//                     onChange={(e) => setHouseNumber(e.target.value)}
//                     aria-invalid={validHouseNumber ? "false" : "true"}
//                     aria-describedby="houseNumberNote"
//                     onFocus={() => setHouseNumberFocus(true)}
//                     onBlur={() => setHouseNumberFocus(false)}
//                 />
//                 <p id="houseNumberNote" className={houseNumberFocus && houseNumber &&
//                     !validHouseNumber ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                         <FontAwesomeIcon icon={faInfoCircle} />
//                         El número de casa debe tener un formato válido.
//                 </p>


//                 <div className="text-center text-white font-bold mt-5">
//                     <input type="submit" disabled={!(validName && validNumber && validCommune && validCity && validDepartmentNumber && validHouseNumber)} className="bg-gray-700 hover:bg-gray-900 w-full h-10 disabled:bg-gray-300" value="CONTINUAR" />
//                 </div>
//             </form>
//         </div>
//     )
// }

// export default DeliveryForm;

import React, { useState, useEffect, useContext } from "react";
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";

const NAME_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]{3,}$/;
const NUMBER_REGEX = /^[0-9]{1,}$/;
const COMMUNE_REGEX = /^(Las Condes|Lo Barnechea|Vitacura)$/;
const DN_REGEX = /^[0-9a-zA-Z_ ]{0,}$/;
const HN_REGEX = /^[0-9a-zA-Z_ ]{0,}$/;

// ── Fuera del componente para evitar remount en cada render ──

const inputCls = (valid, value, touched) => [
    "w-full px-3 py-2.5 rounded-xl border bg-white outline-none transition-all text-[16px] text-[#1e2a1a]",
    touched && value && !valid
        ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
        : valid
            ? "border-[#4a7c2f] focus:border-[#4a7c2f] focus:ring-2 focus:ring-[#edf4e0]"
            : "border-gray-200 focus:border-[#4a7c2f] focus:ring-2 focus:ring-[#edf4e0]",
].join(" ");

function FieldRow({ label, id, valid, value, touched, focus, note, children, optional }) {
    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1.5">
                <label htmlFor={id} className="text-[13px] font-medium text-[#1e2a1a]">
                    {label}
                    {optional && <span className="ml-1 text-[11px] text-gray-400 font-normal">(opcional)</span>}
                </label>
                {valid && value && <FontAwesomeIcon icon={faCheck} className="text-[#4a7c2f] text-[11px]" />}
                {touched && !valid && value && <FontAwesomeIcon icon={faTimes} className="text-red-400 text-[11px]" />}
            </div>
            {children}
            {!focus && touched && value && !valid && (
                <p className="text-[11px] text-red-500 flex items-center gap-1 mt-0.5">
                    <FontAwesomeIcon icon={faInfoCircle} />
                    {note}
                </p>
            )}
        </div>
    );
}

function DeliveryForm() {
    const navigate = useNavigate();
    const { setDeliveryDirection } = useContext(CheckoutContext);

    const [name, setName] = useState("");
    const [validName, setValidName] = useState(false);
    const [nameFocus, setNameFocus] = useState(false);
    const [nameTouched, setNameTouched] = useState(false);

    const [number, setNumber] = useState("");
    const [validNumber, setValidNumber] = useState(false);
    const [numberFocus, setNumberFocus] = useState(false);
    const [numberTouched, setNumberTouched] = useState(false);

    const [commune, setCommune] = useState("");
    const [validCommune, setValidCommune] = useState(false);
    const [communeTouched, setCommuneTouched] = useState(false);

    const [departmentNumber, setDepartmentNumber] = useState("");
    const [validDepartmentNumber, setValidDepartmentNumber] = useState(true);
    const [departmentNumberFocus, setDepartmentNumberFocus] = useState(false);

    const [houseNumber, setHouseNumber] = useState("");
    const [validHouseNumber, setValidHouseNumber] = useState(true);
    const [houseNumberFocus, setHouseNumberFocus] = useState(false);

    const [errMsg, setErrMsg] = useState("");

    async function handleClickContinue(e) {
        e.preventDefault();
        if (!NAME_REGEX.test(name) || !NUMBER_REGEX.test(number) || !COMMUNE_REGEX.test(commune)) {
            setErrMsg("Revisa los datos ingresados");
            return;
        }
        setDeliveryDirection({ streetName: name, streetNumber: number, commune, city: "Santiago", departmentNumber, houseNumber });
        navigate("/checkout/info");
    }

    useEffect(() => { setValidName(NAME_REGEX.test(name)); }, [name]);
    useEffect(() => { setValidNumber(NUMBER_REGEX.test(number)); }, [number]);
    useEffect(() => { setValidCommune(COMMUNE_REGEX.test(commune)); }, [commune]);
    useEffect(() => { setValidDepartmentNumber(DN_REGEX.test(departmentNumber)); }, [departmentNumber]);
    useEffect(() => { setValidHouseNumber(HN_REGEX.test(houseNumber)); }, [houseNumber]);
    useEffect(() => { setErrMsg(""); }, [name, number, commune, departmentNumber, houseNumber]);

    const allValid = validName && validNumber && validCommune && validDepartmentNumber && validHouseNumber;

    return (
        <div className="mx-3 mt-4 mb-2 bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

            {/* Header */}
            <div className="px-4 py-3 bg-[#f6f6ee] border-b border-gray-100 flex items-center gap-2">
                <svg className="w-4 h-4 text-[#4a7c2f]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <p className="text-sm font-semibold text-[#1e2a1a]">Dirección de despacho</p>
            </div>

            <form onSubmit={handleClickContinue} className="px-4 py-4 flex flex-col gap-4">

                {errMsg && (
                    <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 flex items-center gap-2">
                        <FontAwesomeIcon icon={faInfoCircle} className="text-amber-500 text-[13px] flex-shrink-0" />
                        <p className="text-[12px] text-amber-700">{errMsg}</p>
                    </div>
                )}

                {/* Ciudad — fija, no editable */}
                <div className="flex flex-col gap-1">
                    <label className="text-[13px] font-medium text-[#1e2a1a]">Ciudad</label>
                    <div className="w-full px-3 py-2.5 rounded-xl border border-gray-100 bg-[#f6f6ee] text-[16px] text-gray-400">
                        Santiago
                    </div>
                </div>

                {/* Comuna */}
                <FieldRow
                    label="Comuna"
                    id="commune"
                    valid={validCommune}
                    value={commune}
                    touched={communeTouched}
                    focus={false}
                    note="Selecciona Las Condes, Lo Barnechea o Vitacura"
                >
                    <select
                        id="commune"
                        className={inputCls(validCommune, commune, communeTouched)}
                        onChange={(e) => { setCommune(e.target.value); setCommuneTouched(true); }}
                        required
                    >
                        <option value="">Seleccionar comuna</option>
                        <option value="Las Condes">Las Condes</option>
                        <option value="Lo Barnechea">Lo Barnechea</option>
                        <option value="Vitacura">Vitacura</option>
                    </select>
                </FieldRow>

                {/* Calle */}
                <FieldRow
                    label="Calle"
                    id="streetName"
                    valid={validName}
                    value={name}
                    touched={nameTouched}
                    focus={nameFocus}
                    note="Mínimo 3 caracteres, solo letras"
                >
                    <input
                        className={inputCls(validName, name, nameTouched)}
                        type="text"
                        id="streetName"
                        autoComplete="street-address"
                        placeholder="Ej: Av. Apoquindo"
                        onChange={(e) => setName(e.target.value)}
                        required
                        onFocus={() => setNameFocus(true)}
                        onBlur={() => { setNameFocus(false); setNameTouched(true); }}
                    />
                </FieldRow>

                {/* Número */}
                <FieldRow
                    label="Número"
                    id="streetNumber"
                    valid={validNumber}
                    value={number}
                    touched={numberTouched}
                    focus={numberFocus}
                    note="Solo números"
                >
                    <input
                        className={inputCls(validNumber, number, numberTouched)}
                        type="text"
                        id="streetNumber"
                        placeholder="Ej: 4500"
                        onChange={(e) => setNumber(e.target.value)}
                        required
                        onFocus={() => setNumberFocus(true)}
                        onBlur={() => { setNumberFocus(false); setNumberTouched(true); }}
                    />
                </FieldRow>

                {/* Depto y Casa en fila */}
                <div className="grid grid-cols-2 gap-3">
                    <div className="flex flex-col gap-1">
                        <label htmlFor="deptNumber" className="text-[13px] font-medium text-[#1e2a1a]">
                            N° depto <span className="text-[11px] text-gray-400 font-normal">(si aplica)</span>
                        </label>
                        <input
                            className={inputCls(true, departmentNumber, false)}
                            type="text"
                            id="deptNumber"
                            placeholder="Ej: 302"
                            onChange={(e) => setDepartmentNumber(e.target.value)}
                            onFocus={() => setDepartmentNumberFocus(true)}
                            onBlur={() => setDepartmentNumberFocus(false)}
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label htmlFor="houseNum" className="text-[13px] font-medium text-[#1e2a1a]">
                            N° casa <span className="text-[11px] text-gray-400 font-normal">(si aplica)</span>
                        </label>
                        <input
                            className={inputCls(true, houseNumber, false)}
                            type="text"
                            id="houseNum"
                            placeholder="Ej: 12"
                            onChange={(e) => setHouseNumber(e.target.value)}
                            onFocus={() => setHouseNumberFocus(true)}
                            onBlur={() => setHouseNumberFocus(false)}
                        />
                    </div>
                </div>

                {/* Botón */}
                <input
                    type="submit"
                    disabled={!allValid}
                    value={allValid ? "Continuar →" : "Completa la dirección"}
                    className={`
                        w-full py-3 rounded-xl text-sm font-semibold mt-1 transition-all duration-150 cursor-pointer
                        ${!allValid
                            ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                            : "bg-[#2f5a2e] hover:bg-[#3f7a3a] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20"
                        }
                    `}
                />
            </form>
        </div>
    );
}

export default DeliveryForm;